var _line, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConductorLungSageata(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 80,
    viewBox: "0 0 134 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 39.25,
    x2: 134,
    y2: 39.25,
    stroke: "black",
    strokeWidth: 5.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 39.5L6.75 68.5118V10.4881L63 39.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConductorLungSageata);
export default __webpack_public_path__ + "static/media/conductor_lung_sageata.50fa308277ae27bcab68d91464104006.svg";
export { ForwardRef as ReactComponent };